export enum SendFromType {
  ADMIN = 'landlord'
}